import React, { useState, useCallback } from "react";
import { Modal } from "../Components/Modal/Modal";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const MessageContext = React.createContext({
  message: null,
  addMessage: () => {},
  removeMessage: () => {},
});

export function MessageProvider({ children }) {
  const [message, setMessage] = useState(null);

  const removeMessage = () => setMessage(null);

  const addMessage = (text, status) => {
    switch (status) {
      case "success":
        toast.success(text);
        break;
      case "error":
        toast.error(text);
        break;
      case "info":
        toast.info(text);
        break;
      case "warn":
        toast.warn(text);
        break;
      default:
        toast(text);
        break;
    }
  };
  // const addMessage = (text, status) => setMessage({ text, status });

  const contextValue = {
    message,
    addMessage: useCallback((text, status) => addMessage(text, status), []),
    removeMessage: useCallback(() => removeMessage(), []),
  };

  return (
    <MessageContext.Provider value={contextValue}>
      {children}
      <ToastContainer position="top-right" autoClose={5000} />
      {/* {message && <Modal text={message.text} close={removeMessage} />} */}
    </MessageContext.Provider>
  );
}
